import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore session on mount
  useEffect(() => {
    const token = localStorage.getItem('spa_token');
    if (!token) { setLoading(false); return; }
    api.get('/auth/me')
      .then(r => setUser(r.data.data))
      .catch(() => {
        localStorage.removeItem('spa_token');
        localStorage.removeItem('spa_refresh');
      })
      .finally(() => setLoading(false));
  }, []);

  const register = useCallback(async (name, email, password) => {
    const { data } = await api.post('/auth/register', { name, email, password });
    localStorage.setItem('spa_token',   data.data.accessToken);
    localStorage.setItem('spa_refresh', data.data.refreshToken);
    setUser(data.data.user);
    return data.data.user;
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('spa_token',   data.data.accessToken);
    localStorage.setItem('spa_refresh', data.data.refreshToken);
    setUser(data.data.user);
    return data.data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      const refresh = localStorage.getItem('spa_refresh');
      await api.post('/auth/logout', { refreshToken: refresh });
    } catch {}
    localStorage.removeItem('spa_token');
    localStorage.removeItem('spa_refresh');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, register, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}